<template>
  <div class="options-container">
    <FriedH5 class="title">{{ $t('how-did-you-like-signing-with-getaccept') }}</FriedH5>
    <div class="option-group">
      <FriedButton
        class="liked-it"
        data-external="after-sign-container-liked-it-btn"
        :button-type="ButtonType.Tertiary"
        @click="handleOptionPick(AfterSignStep.Signup)"
      >
        <FriedIcon class="icon" icon="thumb-up" />
        {{ $t('yes-loved-it') }}
      </FriedButton>
      <FriedButton
        class="needs-improvments"
        data-external="after-sign-container-needs-improvement-btn"
        :button-type="ButtonType.Tertiary"
        @click="handleOptionPick(AfterSignStep.Feedback)"
      >
        <FriedIcon class="icon" icon="thumb-down" />
        {{ $t('no-it-needs-improvments') }}
      </FriedButton>
    </div>
  </div>
</template>

<script lang="ts">
import { Language } from '@getaccept/lib-shared/src/languages/enums/translation';
import { defineComponent } from 'vue';
import { ButtonType } from '@getaccept/fried-tofu';
import { AfterSignStep } from '../../../types/enums/after-sign-step';
import { userLanguage } from '../../../../lang';

export default defineComponent({
  setup() {
    const handleOptionPick = (option: AfterSignStep) => {
      if (option === AfterSignStep.Signup) {
        if (userLanguage() === Language.Fr) {
          window.open('https://www.getaccept.com/fr/after-sign', '_blank');
        } else {
          window.open('https://www.getaccept.com/after-sign', '_blank');
        }
      } else {
        window.open('https://www.getaccept.com/after-sign-feedback', '_blank');
      }
    };

    return {
      AfterSignStep,
      handleOptionPick,
      ButtonType,
    };
  },
});
</script>
<style lang="scss" scoped>
.options-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;

  .title {
    padding-bottom: $spacing-150;
  }

  .option-group {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: var(--spacing-50);
    margin-bottom: var(--spacing-50);

    @media only screen and (max-width: $xs) {
      margin-top: 0;
    }

    button {
      width: 100%;
      margin: 0 var(--spacing-50);

      @media only screen and (max-width: $xs) {
        margin: 0;
      }

      .icon {
        margin-right: var(--spacing-50);
      }
    }

    @media only screen and (max-width: $xs) {
      flex-wrap: wrap;

      button {
        margin-top: var(--spacing-50);
      }
    }
  }
}
</style>
